import { useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate();

  const login = async (email, password) => {
    try {
      const response = await api.post("/login", { email, password });
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("code", response.data.leroy_code);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("storeCode", response.data.store_business_unit_code);
      localStorage.setItem("isManager", response.data.is_manager);
      setAuthenticated(true);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("code");
    localStorage.removeItem("name");
    localStorage.removeItem("storeCode");
    localStorage.removeItem("isManager");
    setAuthenticated(false);
    navigate("/login");
  };

  return { authenticated, login, logout };
};

export default useAuth;
